// extracted by mini-css-extract-plugin
export default {"forceWrap":"resume-section_forceWrap__-KAE-"};